import { Percent } from '@pancakeswap/sdk'
import { warningSeverity } from 'utils/exchange'
import { ONE_BIPS } from 'config/constants/exchange'
import { ErrorText } from './styleds'

/**
 * Formatted version of price impact text with warning colors
 */
export default function FormattedPriceImpact({ priceImpact }: { priceImpact?: Percent }) {
  const numberPriceImpact = Number(priceImpact.toFixed(2))
  let color = '#ff4343'

  if (numberPriceImpact < 5) {
    color = '#ffb237'
  }

  if (numberPriceImpact < 3) {
    color = '#ffffff'
  }

  if (numberPriceImpact < 1) {
    color = '#64AB2C'
  }
  return (
    <ErrorText fontSize="12px" severity={warningSeverity(priceImpact)}>
      <span
        style={{
          color,
        }}
      >
        {priceImpact ? (priceImpact.lessThan(ONE_BIPS) ? '<0.01%' : `${priceImpact.toFixed(2)}%`) : '-'}
      </span>
    </ErrorText>
  )
}
